<template>
  <div>
    <v-container grid-md > 
        <v-layout style="display: flex; flex-wrap: wrap;">
          <v-flex d-flex class="login-box">
            <main v-if="loggedIn === false">
            <PageIntro v-if="appLogin === false"
              :heading="'Your account has been activated. You can now sign in below'"
              :body="'<p>Now that your account has been verified, you can sign in below with the email address and password used during registration.</p>'" />
            
            <Login />

            
          </main>
          </v-flex>
        </v-layout>
      </v-container>
      <FooterShout v-if="appLogin === false" :type="'register'"/>
  </div>
</template>

<script>
  import Login from '@/components/Login'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      Login,
      PageIntro,
      FooterShout
    },
    data() {
      return {
        from: null,
        appLogin: false,
        loggedIn: true //assume they are logged in
      }
    },
    mounted () {
      // if they are coming from the app specific login URL adapt the page accordingly
      if(this.$router.currentRoute.name === 'app-login'){
        this.appLogin = true
      }
      if(this.$getAuthenticatedUser() != null) {
        this.loggedIn = true;
      }else{
        this.loggedIn = false;
      }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.from = from;
            console.log('before route enter')
            // TODO: Make sure we handle people referred from password reset with a message on sign in page 
        });
    },
    
    
  }
</script>
<style lang="scss" scoped>

.login-box {
  width: 100%;
  @media screen and (min-width: 700px){
    width: 50%;
  }
}

.home-box {
  width: 100%;
  @media screen and (min-width: 700px){
    width: 50%;
  }
}

</style>
